function formatValue(value = '') {
  return value ?? ''
}

export default formatValue
